// (() => {
//     "use strict";

//     /*
//      * Add the product handles that should display the BEST SELLER badge.
//      * Example: "another-product-handle"
//      */
//     const bestSellerHandles = new Set([
//         "wisdom-4a-cordless-cap-lamp-set",
//     ]);

//     const addBestSellerBadges = (root = document) => {
//         const cards = root.querySelectorAll(
//             ".ecom-collection__product-item[data-product-handle]"
//         );

//         cards.forEach((card) => {
//             const productHandle = card.dataset.productHandle;

//             if (!bestSellerHandles.has(productHandle)) {
//                 return;
//             }

//             const wrapper = card.querySelector(
//                 ".ecom-collection__product-item--wrapper"
//             );

//             if (!wrapper || wrapper.querySelector(":scope > .ecom-product-badge")) {
//                 return;
//             }

//             const badge = document.createElement("span");
//             badge.className = "ecom-product-badge";
//             badge.textContent = "BEST SELLER";
//             badge.setAttribute("aria-label", "Best Seller");
//             badge.style.setProperty("font-size", "10px", "important");

//             wrapper.prepend(badge);
//         });
//     };

//     let updateQueued = false;

//     const queueBadgeUpdate = () => {
//         if (updateQueued) {
//             return;
//         }

//         updateQueued = true;

//         requestAnimationFrame(() => {
//             addBestSellerBadges();
//             updateQueued = false;
//         });
//     };

//     const initialiseBadges = () => {
//         addBestSellerBadges();

//         /*
//          * EComposer/slider content can be rendered again after page load.
//          * The observer restores missing badges without creating duplicates.
//          */
//         const observer = new MutationObserver(queueBadgeUpdate);

//         observer.observe(document.body, {
//             childList: true,
//             subtree: true
//         });
//     };

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", initialiseBadges, {
//             once: true
//         });
//     } else {
//         initialiseBadges();
//     }
// })();
// // Best Seller for Collections

// (() => {
//     "use strict";

//     const productSelector =
//         ".grid__item.product-wisdom-4a-cordless-cap-lamp-set";

//     const addBadge = () => {
//         document.querySelectorAll(productSelector).forEach((productCard) => {
//             if (productCard.querySelector(".ecom-grid-badge-bridge")) {
//                 return;
//             }

//             const cardHost =
//                 productCard.querySelector(".card__inner") ||
//                 productCard.querySelector(".card") ||
//                 productCard;

//             if (getComputedStyle(cardHost).position === "static") {
//                 cardHost.style.position = "relative";
//             }

//             /*
//              * Compatibility structure so the existing EComposer
//              * badge CSS also works on the Shopify grid card.
//              */
//             const badgeBridge = document.createElement("div");

//             badgeBridge.className =
//                 "ecom-collection__product-item ecom-grid-badge-bridge";

//             badgeBridge.style.setProperty("position", "absolute", "important");
//             badgeBridge.style.setProperty("inset", "0", "important");
//             badgeBridge.style.setProperty("z-index", "10", "important");
//             badgeBridge.style.setProperty("pointer-events", "none", "important");

//             const badgeWrapper = document.createElement("div");

//             badgeWrapper.className =
//                 "ecom-collection__product-item--wrapper";

//             badgeWrapper.style.setProperty("width", "100%", "important");
//             badgeWrapper.style.setProperty("height", "100%", "important");

//             const badge = document.createElement("span");

//             badge.className = "ecom-product-badge";
//             badge.textContent = "BEST SELLER";
//             badge.setAttribute("aria-label", "Best Seller");
//             badge.style.setProperty("font-size", "10px", "important");

//             badgeWrapper.appendChild(badge);
//             badgeBridge.appendChild(badgeWrapper);
//             cardHost.prepend(badgeBridge);
//         });
//     };

//     let updateQueued = false;

//     const queueUpdate = () => {
//         if (updateQueued) return;

//         updateQueued = true;

//         requestAnimationFrame(() => {
//             addBadge();
//             updateQueued = false;
//         });
//     };

//     const initialise = () => {
//         addBadge();

//         const observer = new MutationObserver(queueUpdate);

//         observer.observe(document.body, {
//             childList: true,
//             subtree: true
//         });
//     };

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", initialise, {
//             once: true
//         });
//     } else {
//         initialise();
//     }
// })();
// // 6A Product Home
// (() => {
//     "use strict";

//     /*
//      * Add the product handles that should display the BEST SELLER badge.
//      * Example: "another-product-handle"
//      */
//     const bestSellerHandles = new Set([
//         "wisdom-lamp-6a",
//     ]);

//     const addBestSellerBadges = (root = document) => {
//         const cards = root.querySelectorAll(
//             ".ecom-collection__product-item[data-product-handle]"
//         );

//         cards.forEach((card) => {
//             const productHandle = card.dataset.productHandle;

//             if (!bestSellerHandles.has(productHandle)) {
//                 return;
//             }

//             const wrapper = card.querySelector(
//                 ".ecom-collection__product-item--wrapper"
//             );

//             if (!wrapper || wrapper.querySelector(":scope > .ecom-product-badge")) {
//                 return;
//             }

//             const badge = document.createElement("span");
//             badge.className = "ecom-product-badge-coal";
//             badge.textContent = "COAL CERTIFIED";
// badge.setAttribute("aria-label", "Coal Certified");
//             badge.style.setProperty("font-size", "10px", "important");

//             wrapper.prepend(badge);
//         });
//     };

//     let updateQueued = false;

//     const queueBadgeUpdate = () => {
//         if (updateQueued) {
//             return;
//         }

//         updateQueued = true;

//         requestAnimationFrame(() => {
//             addBestSellerBadges();
//             updateQueued = false;
//         });
//     };

//     const initialiseBadges = () => {
//         addBestSellerBadges();

//         /*
//          * EComposer/slider content can be rendered again after page load.
//          * The observer restores missing badges without creating duplicates.
//          */
//         const observer = new MutationObserver(queueBadgeUpdate);

//         observer.observe(document.body, {
//             childList: true,
//             subtree: true
//         });
//     };

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", initialiseBadges, {
//             once: true
//         });
//     } else {
//         initialiseBadges();
//     }
// })();
// // 6A Product Collection

// (() => {
//     "use strict";

//     const productSelector =
//         ".grid__item.product-wisdom-lamp-6a";

//     const addBadge = () => {
//         document.querySelectorAll(productSelector).forEach((productCard) => {
//             if (productCard.querySelector(".ecom-grid-badge-bridge")) {
//                 return;
//             }

//             const cardHost =
//                 productCard.querySelector(".card__inner") ||
//                 productCard.querySelector(".card") ||
//                 productCard;

//             if (getComputedStyle(cardHost).position === "static") {
//                 cardHost.style.position = "relative";
//             }

//             /*
//              * Compatibility structure so the existing EComposer
//              * badge CSS also works on the Shopify grid card.
//              */
//             const badgeBridge = document.createElement("div");

//             badgeBridge.className =
//                 "ecom-collection__product-item ecom-grid-badge-bridge";

//             badgeBridge.style.setProperty("position", "absolute", "important");
//             badgeBridge.style.setProperty("inset", "0", "important");
//             badgeBridge.style.setProperty("z-index", "10", "important");
//             badgeBridge.style.setProperty("pointer-events", "none", "important");

//             const badgeWrapper = document.createElement("div");

//             badgeWrapper.className =
//                 "ecom-collection__product-item--wrapper";

//             badgeWrapper.style.setProperty("width", "100%", "important");
//             badgeWrapper.style.setProperty("height", "100%", "important");

//             const badge = document.createElement("span");

//             badge.className = "ecom-product-badge-coal";
// badge.textContent = "COAL CERTIFIED";
// badge.setAttribute("aria-label", "Coal Certified");
//             badge.style.setProperty("font-size", "10px", "important");

//             badgeWrapper.appendChild(badge);
//             badgeBridge.appendChild(badgeWrapper);
//             cardHost.prepend(badgeBridge);
//         });
//     };

//     let updateQueued = false;

//     const queueUpdate = () => {
//         if (updateQueued) return;

//         updateQueued = true;

//         requestAnimationFrame(() => {
//             addBadge();
//             updateQueued = false;
//         });
//     };

//     const initialise = () => {
//         addBadge();

//         const observer = new MutationObserver(queueUpdate);

//         observer.observe(document.body, {
//             childList: true,
//             subtree: true
//         });
//     };

//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", initialise, {
//             once: true
//         });
//     } else {
//         initialise();
//     }
// })();

(() => {
    "use strict";

    /*
     * Product badge configuration
     */
    const ecomBadgeConfig = new Map([
        [
            "wisdom-4a-cordless-cap-lamp-set",
            {
                className: "ecom-product-badge",
                text: "BEST SELLER",
                ariaLabel: "Best Seller"
            }
        ],
        [
            "wisdom-lamp-6a",
            {
                className: "ecom-product-badge-coal",
                text: "COAL CERTIFIED",
                ariaLabel: "Coal Certified"
            }
        ],
        [
            "wisdom-3a-plus-cordless-cap-lamp",
            {
                className: "ecom-product-badge-value",
                text: "BEST VALUE",
                ariaLabel: "Best Value"
            }
        ]
    ]);

    const gridBadgeConfig = [
        {
            productClass:
                "product-wisdom-4a-cordless-cap-lamp-set",
            className: "ecom-product-badge",
            text: "BEST SELLER",
            ariaLabel: "Best Seller"
        },
        {
            productClass: "product-wisdom-lamp-6a",
            className: "ecom-product-badge-coal",
            text: "COAL CERTIFIED",
            ariaLabel: "Coal Certified"
        },
        {
            productClass:
                "product-wisdom-3a-plus-cordless-cap-lamp",
            className: "ecom-product-badge-value",
            text: "BEST VALUE",
            ariaLabel: "Best Value"
        }
    ];

    const ecomCardSelector =
        ".ecom-collection__product-item[data-product-handle]";

    const gridCardSelector = gridBadgeConfig
        .map(({ productClass }) => `.grid__item.${productClass}`)
        .join(",");

    const allCardSelector =
        `${ecomCardSelector},${gridCardSelector}`;

    /*
     * Create badge element
     */
    const createBadge = (config) => {
        const badge = document.createElement("span");

        badge.className = config.className;
        badge.textContent = config.text;
        badge.setAttribute("aria-label", config.ariaLabel);
        badge.style.setProperty(
            "font-size",
            "10px",
            "important"
        );

        return badge;
    };

    /*
     * Check only direct children for an existing badge.
     */
    const hasDirectBadge = (wrapper, className) => {
        return Array.from(wrapper.children).some((child) =>
            child.classList.contains(className)
        );
    };

    /*
     * EComposer product card
     */
    const processEcomCard = (card) => {
        const productHandle = card.dataset.productHandle;
        const config = ecomBadgeConfig.get(productHandle);

        if (!config) {
            return;
        }

        const wrapper = card.querySelector(
            ".ecom-collection__product-item--wrapper"
        );

        if (
            !wrapper ||
            hasDirectBadge(wrapper, config.className)
        ) {
            return;
        }

        wrapper.prepend(createBadge(config));
    };

    /*
     * Find configuration for Shopify collections/all card
     */
    const getGridCardConfig = (card) => {
        return gridBadgeConfig.find(({ productClass }) =>
            card.classList.contains(productClass)
        );
    };

    /*
     * Shopify collections/all product card
     */
    const processGridCard = (productCard) => {
        const config = getGridCardConfig(productCard);

        if (!config) {
            return;
        }

        const existingBridge = productCard.querySelector(
            `.ecom-grid-badge-bridge[data-badge-type="${config.className}"]`
        );

        if (existingBridge) {
            return;
        }

        const cardHost =
            productCard.querySelector(".card__inner") ||
            productCard.querySelector(".card") ||
            productCard;

        /*
         * Avoid repeated getComputedStyle() layout calculations.
         */
        cardHost.style.setProperty("position", "relative");

        const badgeBridge = document.createElement("div");

        badgeBridge.className =
            "ecom-collection__product-item ecom-grid-badge-bridge";

        badgeBridge.dataset.badgeType = config.className;

        badgeBridge.style.setProperty(
            "position",
            "absolute",
            "important"
        );
        badgeBridge.style.setProperty(
            "inset",
            "12px",
            "important"
        );
        badgeBridge.style.setProperty(
            "z-index",
            "10",
            "important"
        );
        badgeBridge.style.setProperty(
            "pointer-events",
            "none",
            "important"
        );

        const badgeWrapper = document.createElement("div");

        badgeWrapper.className =
            "ecom-collection__product-item--wrapper";

        badgeWrapper.style.setProperty(
            "width",
            "100%",
            "important"
        );
        badgeWrapper.style.setProperty(
            "height",
            "100%",
            "important"
        );

        badgeWrapper.appendChild(createBadge(config));
        badgeBridge.appendChild(badgeWrapper);
        cardHost.prepend(badgeBridge);
    };

    /*
     * Process one matching product card
     */
    const processCard = (card) => {
        if (card.matches(ecomCardSelector)) {
            processEcomCard(card);
            return;
        }

        if (
            gridCardSelector &&
            card.matches(gridCardSelector)
        ) {
            processGridCard(card);
        }
    };

    /*
     * Scan only the supplied element and its children.
     * It does not rescan the complete document.
     */
    const scanNode = (node) => {
        if (!(node instanceof Element)) {
            return;
        }

        /*
         * Ignore elements inserted by this script.
         */
        if (
            node.classList.contains("ecom-product-badge") ||
            node.classList.contains("ecom-product-badge-coal") ||
            node.classList.contains("ecom-grid-badge-bridge")
        ) {
            return;
        }

        if (node.matches(allCardSelector)) {
            processCard(node);
        }

        /*
         * Handle cards that are built one child at a time.
         */
        const parentCard = node.closest(allCardSelector);

        if (parentCard) {
            processCard(parentCard);
        }

        node.querySelectorAll(allCardSelector).forEach(processCard);
    };

    /*
     * Batch newly added elements into one animation frame.
     */
    const pendingNodes = new Set();
    let updateFrame = null;

    const queueNodes = (nodes) => {
        nodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                pendingNodes.add(node);
            }
        });

        if (updateFrame !== null) {
            return;
        }

        updateFrame = requestAnimationFrame(() => {
            const nodesToProcess = Array.from(pendingNodes);

            pendingNodes.clear();
            updateFrame = null;

            nodesToProcess.forEach(scanNode);
        });
    };

    const initialiseBadges = () => {
        /*
         * Full scan happens only once on initial page load.
         */
        document
            .querySelectorAll(allCardSelector)
            .forEach(processCard);

        /*
         * One observer for all badges and page structures.
         */
        const observer = new MutationObserver((mutations) => {
            const addedNodes = [];

            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    addedNodes.push(node);
                });
            });

            if (addedNodes.length) {
                queueNodes(addedNodes);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initialiseBadges,
            { once: true }
        );
    } else {
        initialiseBadges();
    }
})();